<template>
  <div>
    <div class="big-title">
      <span>地区及机构</span>
    </div>
    <a-row>

      <a-col span="2"></a-col>
      <a-col span="22">
        <a-space>
          <a-form-model ref="searchForm" layout="inline" :model="formState">
            <!--④查询条件字段名+组件+提示文字+请输入提示文字-->
            <a-form-model-item label="所属市县" prop="region">
              <a-ext-dist-picker v-model="formState.region"></a-ext-dist-picker>
            </a-form-model-item>
            <a-form-model-item label="检测机构" prop="execDept">
              <div style="display: inline-block;width: 200px">
                <a-ext-gov-ji-lian v-model="formState.execDept"></a-ext-gov-ji-lian>
              </div>
            </a-form-model-item>
            <a-form-model-item>
              <a-space>
                <a-button @click="onResetSearch">重置</a-button><a-divider dashed="true" type="vertical" />
                <a-button type="primary" @click="addItem">确认</a-button>
              </a-space>
            </a-form-model-item>
          </a-form-model>
        </a-space>

      </a-col>
    </a-row>
    <div class="big-title">
      <span>需分任务数{{needCheckCount}} 已分配任务数{{checkedCount}}</span>
    </div>
    <a-row>
      <a-row :gutter="4">
        <a-col :span="2">

        </a-col>
        <a-col :span="2">
          <span class="list-header">序列</span>
        </a-col>
        <a-col :span="10">
          <span class="list-header">检测机构名称</span>
        </a-col>
        <a-col :span="6">
          <span class="list-header">检测数</span>
        </a-col>
        <a-col :span="4">

        </a-col>
      </a-row>
      <a-row v-for="(task,index) in localValue" :gutter="4" :style="{margin:'4px'}">
        <a-col :span="2">
        </a-col>
        <a-col :span="2">
          <span class="list-header">{{index+1}}</span>
        </a-col>
        <a-col :span="10">
            <span class="list-header">{{task.execDept}}</span>
        </a-col>
        <a-col :span="6">
          <a-input-number @change="changeNum" v-model="task.checkCount" :min="1" :max="needCheckCount" />
        </a-col>
        <a-col :span="4">
          <a-button v-if="index" type="link" @click="removeItem(task)">删除</a-button>
        </a-col>
      </a-row>
    </a-row>
  </div>
</template>

<script>
import mixin from '../mixin/AExtArrayMixin'
import AExtDistPicker from './AExtDistPicker'

import AExtGovJiLian from './AExtGovJiLian'
import _ from 'lodash'
export default {
    name: "index",
    components:{AExtDistPicker,AExtGovJiLian},
    mixins:[mixin],
    props:{
        total:{
            type:Number,
            default:0
        },
        needCheckCount:{
            type:Number,
            default:0
        }
    },
    data() {
        return {
            formState: {
                //②查询条件字段名
                region: '',
                execDept:''
            },
            checkedCount:0,
            localValue: [],
        }
    },
    created(){

    },
    methods:{
        addItem()
        {
            this.localValue.push({execDept:this.formState.execDept,checkCount:this.formState.checkCount});
        },
        removeItem(task){
            this.localValue.remove(task);
            let total=0;
            this.localValue.forEach(item=>{
                total=total+item.checkCount;
            });
            this.checkedCount=total;
        },
        onResetSearch(){
            this.$refs.searchForm.resetFields();
        },
        changeNum(value)
        {

            let total=0;
            this.localValue.forEach(item=>{
                total=total+item.checkCount;
            });
            this.checkedCount=total;
        }
    }

}
</script>

<style scoped>
  .box{
    display: block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-top-width: 1.02px;
    border-radius: 4px;
    outline: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    text-align: center;
    padding-left: 5px;
    font-weight: 700;
    color: #7c7c7c;
  }

  .total-box{
    font-weight: 700;
    color: #7c7c7c;
  }

  /deep/ .ant-select-selection--single{
    height: 40px;
  }

  /deep/ .ant-select{
    vertical-align: top;
  }

  /deep/ .ant-select-selection__rendered{
    line-height: 40px;
    color: #7c7c7c;
    font-weight: 700;
  }

  /deep/ .ant-input-number {
    height: 40px;
    vertical-align: top;
    width: 100%;
  }
  .list-header {
    padding-left: 20px;
    color: #888888;
    font-weight: 700;
  }

  .big-title {
    color: #444444;
    font-weight: 700;
  }
</style>